<script>
  import { navigate } from "svelte-routing"
  import LogoSbi from "../images/LogoSbi.svelte"
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/User"

  let email = ""
  let password = ""

  let data_user = {
    user: undefined,
    message: undefined,
    loading: false,
  }

  const login = async () => {
    if (!email.trim() || !password.trim()) {
      console.log("Campos vacios")
      return
    }

    data_user.loading = true
    let formData = new FormData()
    formData.append("usuario", email)
    formData.append("clave", password)
    formData.append("ops", "login")

    const response = await fetch(`${BASE_URL}session.php`, {
      method: "POST",
      body: formData,
    })

    const resp = await response.json()

    data_user = {
      user: resp.data,
      loading: false,
    }

    if (resp.status === "success") {
      user.setUser(data_user.user)
      if ($user.actualizar_clave == "1") {
        navigate("/seguridad", { replace: true })
      } else if ($user.verificar == "1") {
        navigate("/verificar", { replace: true })
      } else {
        navigate("/inicio", { replace: true })
      }
    } else {
      data_user.message = resp.message
    }
  }
</script>

<div
  class="Login text-center vh-100 d-flex justify-content-center align-items-center"
>
  <form
    on:submit|preventDefault={login}
    class="p-12 fg-secondary bg-white shadow-sm rounded form-login"
  >
    <div class="mb-5">
      <img
        src="/DOMAWARE-APPS-SBI.svg"
        alt="SBI Logo"
        class="mb-3"
        style="height: 48px;"
      />
    </div>
    <!-- <p class="mb-5">Sistema de Búsquedas Integradas</p> -->
    <!-- <h4 class="mt-5 mb-5 fg-body">Acceder</h4> -->
    <input
      class="form-control mb-3 mt-5"
      type="text"
      placeholder="Ingrese su usuario"
      bind:value={email}
    />
    <input
      class="form-control mb-3"
      type="password"
      placeholder="Ingrese su contraseña"
      bind:value={password}
    />
    <button
      class="form-control btn btn-solid theme-primary mt-3 {data_user.loading
        ? 'disabled'
        : ''}"
      type="submit">{data_user.loading ? "Cargando" : "Ingresar"}</button
    >

    <div class="alert bg-2 border-0 mt-5">
      <p class="text-small my-1">
        Al usar el aplicativo SBI, usted acepta los Términos y Condiciones
        disponibles en la parte inferior de la plataforma.
      </p>
    </div>

    {#if data_user.message !== undefined}
      <div
        class="alert {data_user.message !== 'Bienvenido'
          ? 'theme-danger'
          : 'theme-success'} mt-3 small"
        role="alert"
      >
        {data_user.message}
      </div>
    {/if}
  </form>
</div>

<style>
  .form-login {
    max-width: 400px;
  }
  .text-small {
    font-size: 0.7rem;
  }

</style>
